//json
// {
//          "tenGoi": "LỄ HỘI TRÁI CÂY ĐỒNG THÁP LẦN THỨ I NĂM 2026",
//         "chuDe": "Đồng Tháp – Miền trái ngọt",
//         "thoiGian": "Ngày 05-08/6/2026",
//         "diaDiem": "Quảng trường Hùng Vương, Phường Đạo Thạnh, Tỉnh Đồng Tháp.",
//         "quyMo": "Cấp tỉnh. Dự kiến đón 500.000 lượt khách",
//         "isPublic": true,
//         "_id": "6a0ed2080120714c361437e0",
//         "name": "LỄ HỘI TRÁI CÂY ĐỒNG THÁP LẦN THỨ I NĂM 2026",
//         "unsignedName": "LEHOITRAICAYDONGTHAPLANTHUINAM2026",
//         "createdAt": "2026-05-21T09:36:08.402Z",
//         "modifiedAt": null,
//         "createdBy": null,
//         "modifiedBy": null,
//         "isDeleted": false,
//         "createdAtShow": "21/05/2026 16:36:08",
//         "lastModifiedShow": "",
//         "createdAtString": 20260521
// }

const fromJson = (item) => {
  return {
    _id: item._id,
    tenGoi: item.tenGoi,
    chuDe: item.chuDe,
    thoiGian: item.thoiGian,
    diaDiem: item.diaDiem,
    quyMo: item.quyMo,
    hinhAnh: item.hinhAnh || [],
    isPublic: item.isPublic !== undefined ? item.isPublic : true,
    name: item.name,
    unsignedName: item.unsignedName,
    createdAt: item.createdAt,
    modifiedAt: item.modifiedAt,
    createdBy: item.createdBy,
    modifiedBy: item.modifiedBy,
    isDeleted: item.isDeleted,
    createdAtShow: item.createdAtShow,
    lastModifiedShow: item.lastModifiedShow,
    createdAtString: item.createdAtString,
  };
};

const toJson = (item) => {
  return {
    _id: item._id,
    tenGoi: item.tenGoi,
    chuDe: item.chuDe,
    thoiGian: item.thoiGian,
    diaDiem: item.diaDiem,
    quyMo: item.quyMo,
    hinhAnh: item.hinhAnh || [],
    isPublic: item.isPublic !== undefined ? item.isPublic : true,
    name: item.name,
    unsignedName: item.unsignedName,
    createdAt: item.createdAt,
    modifiedAt: item.modifiedAt,
    createdBy: item.createdBy,
    modifiedBy: item.modifiedBy,
    isDeleted: item.isDeleted,
    createdAtShow: item.createdAtShow,
    lastModifiedShow: item.lastModifiedShow,
    createdAtString: item.createdAtString,
  };
};

const baseJson = () => {
  return {
    _id: null,
    tenGoi: "",
    chuDe: "",
    thoiGian: "",
    diaDiem: "",
    quyMo: "",
    hinhAnh: [],
    isPublic: true,
    name: "",
    unsignedName: "",
    createdAt: "",
    modifiedAt: null,
    createdBy: null,
    modifiedBy: null,
    isDeleted: false,
    createdAtShow: "",
    lastModifiedShow: "",
    createdAtString: "",
  };
};

export const siteInfoModel = { fromJson, toJson, baseJson };

